import ZaiaReaction from "./ZaiaReaction";

export default ZaiaReaction;